import { render, staticRenderFns } from "./searchReault.vue?vue&type=template&id=4c398c24&scoped=true&"
import script from "./searchReault.vue?vue&type=script&lang=js&"
export * from "./searchReault.vue?vue&type=script&lang=js&"
import style0 from "./searchReault.vue?vue&type=style&index=0&id=4c398c24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c398c24",
  null
  
)

export default component.exports